export function isDevEnvironment() {
  return process.env.REACT_APP_API_URL.includes('localhost');
}
